window.addEventListener("load", () => {
  if (typeof Swiper === "undefined") return;

  document.querySelectorAll(".video-carousel-section").forEach((section) => {
    const sectionId = section.id.replace("video-carousel-", "");
    const galleryEl = document.getElementById(`video-gallery-${sectionId}`);
    const swiperEl = section.querySelector(".video-swiper");
    const popup = document.getElementById(`video-popup-${sectionId}`);

    if (!galleryEl || !swiperEl || !popup) return;

    let videoGallery;
    try {
      videoGallery = JSON.parse(galleryEl.textContent);
    } catch {
      return;
    }

    if (!videoGallery.length) return;

    const wrapper = popup.querySelector(".video-popup-wrapper");
    const closeBtn = popup.querySelector(".video-popup-close");
    const prevBtn = popup.querySelector(".video-popup-prev");
    const nextBtn = popup.querySelector(".video-popup-next");
    const counter = popup.querySelector(".video-popup-counter");
    const overlay = popup.querySelector(".video-popup-overlay");

    let currentIndex = 0;

    const video = document.createElement("video");
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.muted = false;
    video.preload = "metadata";
    wrapper.appendChild(video);

    if (videoGallery.length <= 1) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "none";
    }

    function updateCounter() {
      counter.textContent = `${currentIndex + 1} / ${videoGallery.length}`;
    }

    function loadVideo(index) {
      video.pause();

      currentIndex = index;
      const item = videoGallery[currentIndex];

      video.src = item.src;
      if (item.alt) video.setAttribute("aria-label", item.alt);

      video.load();
      video.play().catch(() => {});

      updateCounter();
    }

    function openPopup(index) {
      loadVideo(index);
      popup.classList.add("active");
      popup.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      overlay.style.display = "block";
    }

    function closePopup() {
      video.pause();
      popup.classList.remove("active");
      popup.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      overlay.style.display = "none";
    }

    function showPrev() {
      const newIndex =
        (currentIndex - 1 + videoGallery.length) % videoGallery.length;
      loadVideo(newIndex);
    }

    function showNext() {
      const newIndex = (currentIndex + 1) % videoGallery.length;
      loadVideo(newIndex);
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 10,
      speed: 400,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
        // dynamicBullets: videoGallery.length > 6,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 14,
        },
      },
    });

    swiper.pagination.bullets.forEach((bullet) => {
      bullet.style.width = "48px";
      bullet.style.height = "48px";
      bullet.style.display = "flex";
      bullet.style.alignItems = "center";
      bullet.style.justifyContent = "center";
    });

    section.querySelectorAll(".video-poster-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        openPopup(parseInt(btn.dataset.videoIndex, 10));
      });
    });

    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);
    prevBtn.addEventListener("click", showPrev);
    nextBtn.addEventListener("click", showNext);

    document.addEventListener("keydown", (e) => {
      if (!popup.classList.contains("active")) return;
      if (e.key === "Escape") closePopup();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    });
  });
});
